import React, { useContext } from "react";
import { Link } from "react-router-dom";
import MyContext from "../MyContext/MyContext";
import QuantityControl from "../helper/QuantityControl";

const CartSection = () => {
  const { cart, updateCartQty, removeCartItem } = useContext(MyContext);

  const subtotal = cart.reduce(
    (sum, item) => sum + Number(item.price) * Number(item.quantity),
    0
  );

  /* EMPTY CART UI */
  if (cart.length === 0) {
    return (
      <section className="py-80 text-center">
        <img
          src={"assets/images/thumbs/cart.png"}
          alt="Empty cart"
          style={{ width: "160px", margin: "0 auto 24px" }}
        />
        <h2 className="mt-3 mb-2 fw-bold">I'm Empty!</h2>
        <p className="text-gray-600 mb-4">I've got room for anything.</p>

        <Link
          to="/shop"
          className="text-main-600 fw-semibold text-lg hover-underline"
        >
          Go Shopping!
        </Link>
      </section>
    );
  }

  return (
    <section className="cart py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-9 col-lg-8">
            <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-three">
                  <thead>
                    <tr>
                      <th>Delete</th>
                      <th>Product Name</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>

                  <tbody>
                    {cart.map((item) => (
                      <tr
                        key={
                          item.variantId ||
                          `${item.productId}_${item.color || ""}`
                        }
                      >
                        <td>
                          <button
                            type="button"
                            className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                            onClick={() =>
                              removeCartItem(item.productId, item.color || "")
                            }
                          >
                            <i className="ph ph-x-circle text-2xl d-flex" /> Remove
                          </button>
                        </td>

                        <td>
                          <div className="table-product d-flex align-items-center gap-24">
                            <Link
                              to="#"
                              className="table-product__thumb border border-gray-100 rounded-8 flex-center"
                            >
                              <img src={item.image} alt={item.title} />
                            </Link>

                            <div className="table-product__content text-start">
                              <h6 className="title text-lg fw-semibold mb-8">
                                {item.title}
                              </h6>
                              {item.color && (
                                <span className="text-sm text-gray-500">
                                  Color: {item.color}
                                </span>
                              )}
                            </div>
                          </div>
                        </td>

                        <td>
                          <span className="text-lg fw-semibold">
                            ${Number(item.price).toFixed(2)}
                          </span>
                        </td>

                        <td>
                          <QuantityControl
                            initialQuantity={item.quantity}
                            onIncrease={() =>
                              updateCartQty(
                                item.productId,
                                item.color || "",
                                item.quantity + 1
                              )
                            }
                            onDecrease={() =>
                              updateCartQty(
                                item.productId,
                                item.color || "",
                                Math.max(1, item.quantity - 1)
                              )
                            }
                          />
                        </td>

                        <td>
                          <span className="text-lg fw-semibold">
                            {(Number(item.price) * Number(item.quantity)).toFixed(2)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>

          {/* CART SIDEBAR */}
          <div className="col-xl-3 col-lg-4">
            <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
              <h6 className="text-xl mb-32">Cart Totals</h6>

              <div className="bg-color-three rounded-8 p-24">
                <div className="mb-32 flex-between">
                  <span>Subtotal</span>
                  <span className="fw-semibold">${subtotal.toFixed(2)}</span>
                </div>

                <div className="mb-32 flex-between">
                  <span>Delivery</span>
                  <span className="fw-semibold">Free</span>
                </div>

                <div className="flex-between">
                  <span>Tax</span>
                  <span className="fw-semibold">{(subtotal * 0.05).toFixed(2)}</span>
                </div>
              </div>

              <div className="bg-color-three rounded-8 p-24 mt-24">
                <div className="flex-between">
                  <span className="text-xl fw-semibold">Total</span>
                  <span className="text-xl fw-semibold">
                    {(subtotal * 1.05).toFixed(2)}
                  </span>
                </div>
              </div>

              <Link to="/checkout" className="btn btn-main mt-40 py-18 w-100 rounded-8">
                Proceed to checkout
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CartSection;
 